import { useState, useEffect } from "react";
import { fetchAuthSession } from "aws-amplify/auth";

import eyeVisibleIcon from "../visibleEye.png";
import eyeInvisibleIcon from "../invisibleEye.png";
import copyIcon from "../copy.png"; // Add an icon for the Copy button
import "../App.css";

export const QAAuth = (): JSX.Element => {
  const [credentials, setCredentials] = useState<any>(null);
  const [isQA, setQA] = useState<boolean>(false);
  const [accessKeyVisible, setAccessKeyVisible] = useState<boolean>(false);
  const [secretKeyVisible, setSecretKeyVisible] = useState<boolean>(false);
  const [sessionTokenVisible, setsessionTokenVisible] =
    useState<boolean>(false);

  const getAuthenticatedUser = async () => {
    try {
      const { tokens } = await fetchAuthSession();
      if (
        !tokens?.accessToken.payload["cognito:groups"] ||
        !(tokens?.accessToken.payload["cognito:groups"] as any[]).some(
          (group: string) => group === "QA" || group === "Admins"
        )
      ) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error("Fetching current authenticated user error:", error);
      return false;
    }
  };

  const getUserCredentials = async () => {
    try {
      let authSession = await fetchAuthSession();
      setCredentials(authSession.credentials);
    } catch (error) {
      console.error("Fetching current authenticated user error:", error);
    }
  };

  useEffect(() => {
    const getUserDetails = async () => {
      const isQA = await getAuthenticatedUser();
      setQA(isQA);
      if (isQA) {
        await getUserCredentials();
      }
    };
    getUserDetails();
  }, []);

  if (!isQA) {
    return <div>Only QA Group allowed!</div>;
  }

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {});
  };

  const setAccessKey = () => {
    setAccessKeyVisible(!accessKeyVisible);
  };
  const setSecretKey = () => {
    setSecretKeyVisible(!secretKeyVisible);
  };
  const setSessionToken = () => {
    setsessionTokenVisible(!sessionTokenVisible);
  };

  return (
    <div>
      {credentials ? (
        <div className="Qacreds-page">
          Access Key
          <div className="Qacreds-div">
            <button onClick={setAccessKey} className="Qacreds-button">
              <img
                src={accessKeyVisible ? eyeVisibleIcon : eyeInvisibleIcon}
                className="Qacreds-icon"
                alt="See Access Key"
              />
            </button>
            <button
              onClick={() => copyToClipboard(credentials.accessKeyId)}
              className="Qacreds-button"
            >
              <img
                src={copyIcon}
                className="Qacreds-icon"
                alt="Copy Access Key"
              />
            </button>
            {accessKeyVisible ? (
              <p>{credentials.accessKeyId}</p>
            ) : (
              <p>XXXXXXXX</p>
            )}
          </div>
          Secret Key
          <div className="Qacreds-div">
            <button onClick={setSecretKey} className="Qacreds-button">
              <img
                src={secretKeyVisible ? eyeVisibleIcon : eyeInvisibleIcon}
                className="Qacreds-icon"
                alt="See Secret Key"
              />
            </button>
            <button
              onClick={() => copyToClipboard(credentials.secretAccessKey)}
              className="Qacreds-button"
            >
              <img
                src={copyIcon}
                className="Qacreds-icon"
                alt="Copy Secret Key"
              />
            </button>
            {secretKeyVisible ? (
              <p>{credentials.secretAccessKey}</p>
            ) : (
              <p>XXXXXXXX</p>
            )}
          </div>
          Session Token
          <div className="Qacreds-div">
            <button onClick={setSessionToken} className="Qacreds-button">
              <img
                src={sessionTokenVisible ? eyeVisibleIcon : eyeInvisibleIcon}
                className="Qacreds-icon"
                alt="See Session Token"
              />
            </button>
            <button
              onClick={() => copyToClipboard(credentials.sessionToken)}
              className="Qacreds-button"
            >
              <img
                src={copyIcon}
                className="Qacreds-icon"
                alt="Copy Session Token"
              />
            </button>
            {sessionTokenVisible ? (
              <p>{credentials.sessionToken}</p>
            ) : (
              <p>XXXXXXXX</p>
            )}
          </div>
        </div>
      ) : (
        <p>i got nothing..</p>
      )}
    </div>
  );
};
